import { render } from "./AuthUserNote.vue?vue&type=template&id=360765b8"
import script from "./AuthUserNote.vue?vue&type=script&lang=ts"
export * from "./AuthUserNote.vue?vue&type=script&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "360765b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('360765b8', script)) {
    api.reload('360765b8', script)
  }
  
  module.hot.accept("./AuthUserNote.vue?vue&type=template&id=360765b8", () => {
    api.rerender('360765b8', render)
  })

}

script.__file = "src/views/AuthenticateUserPage/components/AuthUserNote.vue"

export default script